import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const CheckmarkIcon = props => {
  return /*#__PURE__*/_jsxs("svg", Object.assign({
    height: "16px",
    version: "1.1",
    viewBox: "0 0 15 15",
    width: "16px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [/*#__PURE__*/_jsx("title", {
      children: "Check"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("filter", {
        id: "filter-1",
        children: /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceGraphic",
          type: "matrix",
          values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.31063462,0.996062609 L2.55782692,4.8356342 L0.689365385,2.92424979 C0.531596154,2.76283298 0.276096154,2.76283298 0.118326923,2.92424979 C-0.0394423077,3.0856666 -0.0394423077,3.34707369 0.118326923,3.5084905 L2.27217308,5.712133 C2.35105769,5.7928414 2.45444231,5.83333333 2.55782692,5.83333333 C2.66094231,5.83333333 2.76432692,5.7928414 2.84321154,5.712133 L6.88167308,1.58030332 C7.03944231,1.41888651 7.03944231,1.15747942 6.88167308,0.996062609 C6.72390385,0.834645797 6.46840385,0.834645797 6.31063462,0.996062609",
        id: "path-2"
      })]
    }), /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      id: "User-Guide-Academy-Prominence-STATS",
      stroke: "none",
      strokeWidth: "1",
      children: /*#__PURE__*/_jsx("g", {
        id: "Software-landing-page",
        transform: "translate(-1030.000000, -1267.000000)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Copy-and-screen",
          transform: "translate(184.000000, 383.000000)",
          children: /*#__PURE__*/_jsx("g", {
            id: "Group-10-Copy-2",
            transform: "translate(846.000000, 879.000000)",
            children: /*#__PURE__*/_jsxs("g", {
              id: "Check",
              transform: "translate(0.000000, 5.000000)",
              children: [/*#__PURE__*/_jsx("g", {
                fill: "currentColor",
                id: "Icons/Feedback&Ratings/Favorite/circleFilled",
                children: /*#__PURE__*/_jsx("circle", {
                  cx: "7.5",
                  cy: "7.5",
                  id: "Oval",
                  r: "7.5"
                })
              }), /*#__PURE__*/_jsx("g", {
                filter: "url(#filter-1)",
                id: "Icons/Actions/Add",
                transform: "translate(4.000000, 4.000000)",
                children: /*#__PURE__*/_jsxs("g", {
                  children: [/*#__PURE__*/_jsx("mask", {
                    fill: "white",
                    id: "mask-3",
                    children: /*#__PURE__*/_jsx("use", {
                      xlinkHref: "#path-2"
                    })
                  }), /*#__PURE__*/_jsx("use", {
                    fill: "currentColor",
                    id: "Icons/Utilities/Success",
                    xlinkHref: "#path-2"
                  })]
                })
              })]
            })
          })
        })
      })
    })]
  }));
};

export default CheckmarkIcon;